/**
 * A `status_note` field is one stored column shown as two inputs. These two
 * functions are the whole mapping, shared by the input and by validation so
 * they cannot disagree.
 *
 * Stored form: `"<status>"` or `"<status><separator><comment>"`. Split on the
 * FIRST separator: "Decline - opted out - 2026" is status "Decline" with the
 * comment "opted out - 2026".
 */

import type { StatusNoteField } from '../api/types'

export interface StatusNote {
  /** '' when the stored value does not start with a listed status. */
  status: string
  note: string
}

export function splitStatusNote(field: StatusNoteField, value: unknown): StatusNote {
  const text = value === null || value === undefined ? '' : String(value)
  const at = text.indexOf(field.separator)
  const head = (at >= 0 ? text.slice(0, at) : text).trim()
  if (field.statuses.includes(head)) {
    return { status: head, note: at >= 0 ? text.slice(at + field.separator.length) : '' }
  }
  // Old data with no recognised status: keep every word, in the comment, so
  // nothing is lost and whoever edits it next picks a proper status.
  return { status: '', note: text }
}

export function joinStatusNote(field: StatusNoteField, { status, note }: StatusNote): string | null {
  const trimmed = note.trim()
  if (!status) return trimmed ? note : null
  return trimmed ? `${status}${field.separator}${note}` : status
}
